import styled from "styled-components";

export const ContainerMain = styled.div`
  display: flex;
  flex-direction: row;
  overflow-y: auto;
  gap: 10px;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    height: 100vh;
    align-items: stretch;
  }
`;

export const TradingViewContainer = styled.div`
  width: 70%;
  height: calc(100vh - 140px);

  @media (max-width: 768px) {
    height: 80vh;
    min-width: 0;
    display: flex;
    border-radius: 20px 0 0 20px;
    width: 100%;
  }
`;

export const WatchListContainer = styled.div`
  width: 30%;
  height: calc(100vh - 140px);
  overflow-y: auto;
  border: 1px solid #393c45;
  border-radius: 5px;

  @media (max-width: 768px) {
    height: 400px;
    width: auto;
  }
`;
